export const DEFAULT_ROWS_NUMBER = 3;
export const DEFAULT_ROW_HEIGHT = 30;
export const SPACED_ROW_HEIGHT = 32;
export const MENU_SCROLLBAR_HEIGHT = 376;
export const SPACING = 8;
//# sourceMappingURL=constants.js.map